// FR
export const reservasSmallHc = {
  createAlerta: {
    title: `Créer un nouveau rappel`,
    infoHeading: `Informations du rappel`,
    selectPropertyLabel: `Sélectionnez le logement auquel vous souhaitez attribuer le rappel`,
    dayLabel: `Sélectionnez un jour de la semaine :`,
    dayMonday: `Lundi`,
    dayTuesday: `Mardi`,
    dayWednesday: `Mercredi`,
    dayThursday: `Jeudi`,
    dayFriday: `Vendredi`,
    daySaturday: `Samedi`,
    daySunday: `Dimanche`,
    selectTimeLabel: `Sélectionnez l'heure`,
    sendAtLabel: `Sera envoyé à :`,
    minutesLabel: `Avec {minutes} minutes :`,
    previewPre: `L'alerte sera envoyée aux clients les`,
    previewMid: `à`,
    descriptionLabel: `Description de l'alerte`,
    descriptionPlaceholder: `Saisissez une description pour l'alerte`,
    messageTypeLabel: `Sélectionnez le type de message à envoyer.`,
    messageTypeSimple: `Message simple`,
    messageTypeLink: `Message avec un lien à la fin`,
    messageTypeFile: `Message avec un fichier joint à la fin`,
    linkFieldLabel: `Saisissez le lien à envoyer avec le rappel`,
    fileFieldLabel: `Chargez le fichier à envoyer avec le rappel`,
    fileNameLabel: `Nom du fichier`,
    cancel: `Annuler`,
    save: `Enregistrer le rappel`,
    errorDayRequired: `Le jour est requis`,
    errorTimeRequired: `L'heure est requise`,
    errorSelectMinutes: `Sélectionnez les minutes`,
    errorDescriptionRequired: `La description est requise`,
    errorAttachmentRequired: `La pièce jointe est requise ou sélectionnez le type de message simple`,
  },
  reservationData: {
    statusConfirmed: `Confirmé`,
    statusRejected: `Refusé`,
    statusTentative: `Sous réserve de disponibilité`,
    statusWithinCheckin: `Dans les horaires d'arrivée`,
    statusFree: `Sans frais`,
    modalTitleApprove: `Approuver la demande ?`,
    modalTitleApproveTime: `Approuver à une autre heure ?`,
    modalTitlePrioritize: `Prioriser cette arrivée ?`,
    modalTitleReject: `Refuser la demande ?`,
    modalTitleDefault: `Confirmer ?`,
    modalTextApprove: `Vous allez approuver l'arrivée anticipée de`,
    modalTextApproveTime: `Vous confirmerez l'arrivée à l'heure que vous indiquez pour`,
    modalTextPrioritize: "Nous lui dirons que vous ferez tout votre possible pour que ce soit prêt à cette heure, même si cela dépend du départ précédent et du ménage. Envoyé à",
    modalTextReject: `Vous allez refuser l'arrivée anticipée de`,
    modalTextDefault: `Confirmer pour`,
    modalCtaApprove: `Oui, approuver`,
    modalCtaApproveTime: `Confirmer l'heure`,
    modalCtaPrioritize: `Oui, informer`,
    modalCtaReject: `Oui, refuser`,
    modalCtaDefault: `Confirmer`,
    kpiRoom: `Chambre`,
    kpiLodging: `Logement`,
    guestsCount: `client | clients`,
    adultsCount: `adulte | adultes`,
    childrenCount: `enfant | enfants`,
    infantsCount: `bébé | bébés`,
    roomsCountValue: `{count} chambres`,
    holderRole: `Titulaire de la réservation`,
    noEmail: `Aucun e-mail attribué`,
    writeWhatsapp: `Écrire sur WhatsApp`,
    noPhoneTitle: `Sans téléphone, l'envoi via WhatsApp est impossible. Vous pouvez l'ajouter dans «Modifier la réservation».`,
    noPhone: `Aucun téléphone attribué`,
    kpiCheckin: `Arrivée`,
    kpiCheckout: `Départ`,
    earlyRequested: `Arrivée anticipée demandée`,
    arrivalRequested: `Heure d'arrivée demandée`,
    arrivesAt: `Arrive à {time}`,
    actionApprove: `Approuver`,
    actionOtherTime: `Autre heure`,
    actionPrioritize: `Prioriser`,
    actionReject: `Refuser`,
    awaitingPayment: "En attente du paiement du voyageur",
    cannotUndo: `Cette action est irréversible.`,
    checkinTimeLabel: `Heure d'arrivée`,
    earlyPrioritisedTitle: "Arrivée anticipée prioritaire",
    earlyApprovedTitle: "Arrivée anticipée acceptée",
    earlyRejectedTitle: "Arrivée anticipée refusée",
    earlyLineApproved: "Arrivera à {time}",
    earlyLineApprovedOther: "Arrivera à {time} · avait demandé {original}",
    earlyLineRejected: "Avait demandé {time} · arrivera à l'heure habituelle",
    earlyLineRejectedStd: "Avait demandé {time} · arrivera à l'heure habituelle ({std})",
    earlyLinePrioritised: "Souhaite arriver à {time} · on lui a dit qu'on ferait le maximum",
    extRequestedTitle: "Prolongation du séjour demandée",
    extAwaitingTitle: "Prolongation du séjour en attente de paiement",
    extConfirmedTitle: "Prolongation du séjour confirmée",
    extNights: "Nuits ajoutées : {nights} · nouveau départ le {date}",
    extAtProperty: "{amount} à payer sur place",
    extPendingHost: "en attente de votre accord",
    lateRequestedTitle: "Départ tardif demandé",
    lateAwaitingTitle: "Départ tardif en attente de paiement",
    lateConfirmedTitle: "Départ tardif confirmé",
    lateRejectedTitle: "Départ tardif refusé",
    lateLeavesAt: "Part à {time}",
    lateWantsToLeave: "Souhaite partir à {time}",
    lateInsteadOf: "(au lieu de {std})",
    latePaid: "Payé : {amount}",
    lateCourtesy: "Heure de courtoisie, sans frais",
    lateFree: "Sans frais",
    lateCash: "{amount} en espèces au départ",
    lateUnpaid: "{amount}, pas encore payé",
    lateLineRejected: "A demandé à partir à {time} · part à l'heure habituelle",
    lateLineRejectedStd: "A demandé à partir à {time} · part à l'heure habituelle ({std})",
    requestedTimeHint: "Le client a demandé {time}",
    toastApproved: "Arrivée anticipée acceptée",
    toastApprovedTime: "Nouvelle heure d'arrivée acceptée",
    toastPrioritised: "Arrivée anticipée prioritaire",
    toastRejected: "Arrivée anticipée refusée",
    toastNotified: "Le client a déjà été prévenu.",
    toastNotNotified: "Impossible de prévenir le client : écrivez-lui vous-même.",
    toastAlreadyDecided: "Cette demande était déjà traitée : le client n'a pas été recontacté.",
    toastError: "Impossible d'enregistrer la décision. Réessayez.",
    toastAlreadyPaid: "Elle était déjà payée : rien n'a été facturé à nouveau.",
    toastRefundMaybeDue: "Le client a payé pour arriver plus tôt et arrive maintenant à l'heure habituelle : remboursez-le si nécessaire.",
    actionReadyNow: "Il peut entrer",
    actionNotPossible: "Ce ne sera pas possible",
    toastPaymentLinkFailed: "Le lien de paiement n'a pas pu être créé : encaissez-le autrement.",
    arrivalApprovedTitle: "Heure d'arrivée confirmée",
    arrivalRejectedTitle: "Heure d'arrivée refusée",
    arrivalLineRejected: "Souhaitait arriver à {time}",
    modalTextApproveArrival: "Vous allez confirmer l'heure d'arrivée de",
    modalTextRejectArrival: "Vous allez refuser l'heure d'arrivée de",
    toastArrivalApproved: "Heure d'arrivée confirmée",
    toastArrivalRejected: "Heure d'arrivée refusée",
    cancel: `Annuler`,
  },
  minStayModal: {
    summaryNoData: `Aucune donnée dans la plage sélectionnée`,
    summaryHintMixed: `Plusieurs séjours minimums ont été détectés dans la plage. Le champ est réglé sur 1 nuit pour que vous définissiez la nouvelle valeur.`,
    summaryHintSingle: `Le champ a été chargé avec le séjour minimum actuel de la plage sélectionnée.`,
    errorMinOne: `Le séjour minimum doit être d'au moins 1 nuit.`,
    opStartLabel: `Modification du séjour minimum…`,
    successUpdated: `Séjour minimum mis à jour avec succès`,
    errorUpdate: `Erreur lors de la mise à jour du séjour minimum`,
    errorUnknown: `Erreur inconnue`,
    title: `Séjour minimum`,
    description: `Définissez le séjour minimum en nuits pour la plage de dates sélectionnée.`,
    detectedLabel: `Séjours minimums détectés`,
    minStayLabel: `Séjour minimum (nuits)`,
    decreaseAria: `Diminuer le séjour minimum`,
    minNightsPlaceholder: `Ex : 2`,
    increaseAria: `Augmenter le séjour minimum`,
    hint: `Nombre minimum de nuits que le client doit réserver.`,
    cancel: `Annuler`,
    save: `Enregistrer`,
  },
  modalCompleteReservation: {
    errorContactRequired: `Pour continuer, vous devez remplir l'un des deux champs (téléphone ou e-mail)`,
    successMsg: `Données de la réservation complétées avec succès`,
    successTitle: `Opération réalisée avec succès`,
    title: `Compléter la réservation`,
    bookingDateLabel: `Dates de la réservation`,
    checkin: `Arrivée`,
    checkout: `Départ`,
    phoneRequiredHint: `* Seul champ requis`,
    emailHint: `*Si vous indiquez l'e-mail, le client n'aura pas à le saisir`,
    responsibleLabel: `Saisissez le nom du responsable`,
    responsiblePlaceholder: `Responsable de la réservation`,
    scheduleLabel: `Programmez la date d'envoi du lien d'enregistrement.`,
    scheduleAuto: `Envoi automatique`,
    schedule24: `24 heures avant l'arrivée`,
    schedule48: `48 heures avant l'arrivée`,
    schedule72: `72 heures avant l'arrivée`,
    scheduleWeek: `Une semaine avant l'arrivée`,
    cancel: `Annuler`,
    complete: `Compléter la réservation`,
  },
  payData: {
    errorNoPaymentRecord: `Impossible d'identifier l'enregistrement de paiement.`,
    partialLinkGenerated: `Lien de paiement généré avec succès.`,
    errorGenerateLink: `Impossible de générer le lien.`,
    partialRegistered: `Paiement partiel enregistré.`,
    errorSavePartial: `Impossible d'enregistrer le paiement partiel.`,
    whatsappPartialMsg: `Bonjour {name}, nous vous partageons le lien pour finaliser le paiement en attente de votre réservation : {url}`,
    errorInvoicingNotActive: `La facturation électronique n'est pas activée sur votre forfait.`,
    fieldBillingProfile: `Profil de facturation`,
    fieldCountry: `Pays`,
    fieldLegalName: `Raison sociale`,
    fieldTaxId: `NIF/CIF/NIT`,
    fieldAddressStreet: `Adresse`,
    fieldAddressCity: `Ville`,
    fieldAddressRegion: `Région`,
    fieldAddressZip: `Code postal`,
    fieldEmail: `E-mail`,
    fieldIsActive: `Activer le profil`,
    errorBillingIncomplete: `Complétez vos informations de facturation. Manquant : {fields}`,
    invoiceLinkCopied: `Lien de facturation copié.`,
    reservationHasInvoice: `Cette réservation a déjà une facture.`,
    errorLoadReceipt: `Impossible de charger le reçu.`,
    errorDownloadReceipt: `Impossible de télécharger le reçu.`,
    guestOutOfWindow: `Le client est en dehors de la fenêtre de 24h de WhatsApp.`,
    errorSendReceipt: `Erreur lors de l'envoi du reçu.`,
    charge: `Frais`,
    lodging: `Logement`,
    servicesExtras: `Services et extras`,
    free: `Gratuit`,
    ivaIncluded: `(TVA {rate}% incluse)`,
    includedInPrice: `(incluse dans le prix)`,
    pendingCharge: `Paiement en attente`,
    viewBreakdown: `Voir le détail des prix`,
    viewReceipt: `Voir le reçu`,
    receiptInfoPre: `Reçu informatif. La facture électronique est émise depuis l'onglet`,
    chargesTab: `Frais`,
    receiptInfoNoInvoice: `Reçu informatif disponible. Pour la facturation électronique, configurez vos informations de facturation.`,
    reservationNumber: `Réservation n° {code}`,
    currentStatus: `Statut actuel`,
    willChangeTo: `Passera à :`,
    saving: `Enregistrement…`,
    breakdownTitle: `Détail des prix`,
    discounts: `Remises`,
    taxesAndFees: `Taxes et frais`,
    ivaIncludedInPrice: `TVA ({rate}%) incluse dans le prix : {amount}`,
    includesTaxes: `Inclut {amount} de taxes incluses dans le prix`,
    total: `Total`,
    close: `Fermer`,
    loadingReceipt: `Chargement du reçu…`,
    stayReceipt: `Reçu de séjour · {date}`,
    downloadPdf: `Télécharger le PDF`,
    sending: `Envoi…`,
    sent: `Envoyé !`,
    outOfWindow: `Hors fenêtre de 24h`,
    sendWhatsapp: `Envoyer via WhatsApp`,
    stayDetail: `Détails du séjour`,
    ivaIncludedShort: `TVA {rate}% incluse`,
    discount: `Remise`,
    nightsCount: `nuit | nuits`,
    additionalCharges: `Frais supplémentaires`,
    ivaShort: `TVA {rate}%`,
    charged: `Encaissé`,
    pending: `En attente`,
    receiptGeneratedBy: `Reçu généré par`,
    done: `Terminé`,
    registerPartial: `Enregistrer un paiement partiel`,
    reservationTotal: `Total de la réservation`,
    amountReceived: `Montant déjà reçu`,
    paid: `Versé`,
    pendingBalance: `Solde restant`,
    amountExceedsTotal: `Le montant reçu dépasse le total. Utilisez le statut`,
    paidStatus: `Payé`,
    internalNote: `Note interne`,
    optional: `(facultatif)`,
    notePlaceholder: `Ex : Premier paiement reçu par virement...`,
    autoLinkNote: `Lors de l'enregistrement, le lien de paiement sera automatiquement mis à jour à`,
    cancel: `Annuler`,
    savePartial: `Enregistrer le paiement partiel`,
    roomsCount: `{count} chambre | {count} chambres`,
    groupNotePre: `Montant de la`,
    groupNoteCombined: `réservation combinée`,
    groupNoteMid: `détail par chambre ci-dessous.`,
  },
};
